var exports = {
  "M": "FormControl__lY_mjd",
};

module.exports = exports;
